import React from "react"
import SideBar from "../../common/layout/sidebar.component.jsx"
import GenericListing from "../../common/listing/generic-listing/GenericListing"
import ContactTabs from "../../customer/components/contactTabsComponent"
import { ObjectType } from "../../state/listing/generic-listing/index"

const CompanyListing = () => {
    SideBar.activateMenu("contact")

    return (
        <>
            <ContactTabs />
            <GenericListing
                objectType={ObjectType.COMPANIES}
                selectableRows
            />
        </>
    )
}
export default CompanyListing


// WEBPACK FOOTER //
// ./src/company/listing/CompanyListing.tsx